import React, { useEffect } from "react";
import {
  FaCheckCircle,
  FaGlobeAsia,
  FaBriefcase,
  FaSmile,
} from "react-icons/fa";
import "./Stats.css";

const Stats = () => {
  useEffect(() => {
    const counters = document.querySelectorAll("[data-count]");

    const runCounter = (counter) => {
      const target = +counter.dataset.count;
      const suffix = counter.innerText.replace(/[0-9]/g, ""); // +, %, Years
      let current = 0;
      const step = Math.max(1, Math.floor(target / 40));

      const update = () => {
        current += step;
        if (current >= target) {
          counter.innerText = target + suffix;
        } else {
          counter.innerText = current + suffix;
          requestAnimationFrame(update);
        }
      };

      update();
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            runCounter(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );

    counters.forEach((counter) => observer.observe(counter));
  }, []);

  return (
    <section className="uniq-oglitz-stats">
      <div className="uniq-oglitz-stats__container">
        <div className="uniq-oglitz-stats__item">
          <span className="uniq-oglitz-stats__icon">
            <FaCheckCircle />
          </span>
          <h3 data-count="50">0+</h3>
          <p>Projects Delivered</p>
        </div>

        <div className="uniq-oglitz-stats__item">
          <span className="uniq-oglitz-stats__icon">
            <FaGlobeAsia />
          </span>
          <h3>India & UAE</h3>
          <p>Global Operations</p>
        </div>

        <div className="uniq-oglitz-stats__item">
          <span className="uniq-oglitz-stats__icon">
            <FaBriefcase />
          </span>
          <h3 data-count="5">0+ Years</h3>
          <p>Industry Experience</p>
        </div>

        <div className="uniq-oglitz-stats__item">
          <span className="uniq-oglitz-stats__icon">
            <FaSmile />
          </span>
          <h3 data-count="100">0%</h3>
          <p>Client Satisfaction</p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
